module.exports = __webpack_public_path__ + "img/slide-1-desk-min.04099049.jpg";